import type { FC } from "react";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { useTranslations } from "@jti/ui";

type DeliveryLimitMessageBoxProps = { isVisible: boolean };

export const DeliveryLimitMessageBox: FC<DeliveryLimitMessageBoxProps> = ({ isVisible }) => {
  const { __ } = useTranslations();

  return isVisible ? <AlertBanner tone="warning" description={__("libs.ui.notification.limit.delivery_city")} /> : null;
};
